( function () {
    'use strict';
    /**
     * @namespace
     */
    master.local = {
        init: function () {
            master.local.inactive();
        },
        /** @function */
        /**
         * Check if workshop has active booking
         */
        inactive: function () {
            if ( jQuery( 'body' ).data( 'area' ) === 'frontpage' && jQuery( 'body' ).data( 'booking' ) === 'False' ) {
                if ( jQuery( '.js-master-local-inactive-modal' ).length === 1 ) {
                    jQuery( '.js-master-local-inactive-modal' ).modal();
                }
            }
        }
    };
}() );
